import LockKeyholeIcon from 'assets/svg/lock-keyhole/lock-keyhole-icon.svg'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import styled from 'styled-components'

const MenuLinkPinActivation = styled.a`
  background-color: ${theme.colors.orange};
  color: ${theme.colors.white};
  justify-content: center;
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 2px 2px 8px;
  border-radius: ${theme.radius.base};
`

const StyledLockKeyholeIcon = styled(LockKeyholeIcon)`
  margin-right: 12px;
  path {
    fill: ${theme.colors.white};
  }
`

interface IMenuPin {
  pinStatus?: string
}

function MenuPin({ pinStatus }: IMenuPin): JSX.Element {
  if (pinStatus === 'NOT_SET') {
    return (
      <MenuLinkPinActivation href={`${WEB_DESKTOP_RALALI_URL}/pin`}>
        <StyledLockKeyholeIcon />
        <Typography fontWeight="bold" color="white">
          Aktivasi PIN
        </Typography>
      </MenuLinkPinActivation>
    )
  }
  return null
}

export default MenuPin
